module.exports = __webpack_public_path__ + "img/bonus4.1641ef5f.png";